import { Injectable } from '@angular/core';
import { VenueRate } from './venue-rate.model';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VenueRatesService {

    selectedRow!: VenueRate | any;
    defaultFilterArray: any = [];
    isLoadingResults = true;
    rowcount!: number;
    totalRecords: any = 0;
    startLimit: number = 0;
    endLimit: number = 0;
    defaultData: any;
    dataset: any[] = [];

    
  constructor(private sharedHttpClientService: SharedHttpClientService,
        private userService: UserService,
        private gridService: GridService,
        private readonly urlsService: UrlsService) { 
        
  }

  defaultFilter() {
    this.defaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Venue Name', 'columnname': 'venueName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Venue MPID', 'columnname': 'venueMPID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
    ];
  }

  getDefaultFilters(){
    return this.defaultFilterArray;
  }

  reloadData(){
      let payload = {
        "mpid": this.userService.getActiveMPID(),
        "data": this.defaultFilterArray,
        "startLimit": this.startLimit,
        "endLimit": this.rowcount
    }
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueRates_List), payload)
          .pipe(map((response: Response) => {
              return response;
            })).subscribe({
              next: (data: any) => {
                this.isLoadingResults = false;
                let response: any = data;
                this.dataset = response.Data;
                this.defaultData = this.dataset;
                this.totalRecords = response.totalCount;
                this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
              },        
              error: (err: HttpErrorResponse) => {
                this.isLoadingResults = false;
              }
        });  
  }


  getData(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueRates_List), payload);
  }
  getAdd(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueRates_Add), payload);
  }
  getEdit(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueRates_Edit), payload);
  }

  getDelete(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueRates_Delete), payload);
  }


}
